import { getPermissions } from "@/helper/collection";

export const DistributorRoutes = {
  path: "/distributor",
  name: "Distributor",
  redirect: "/distributor/distributor-share-type",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/DistributorContainer/DistributorsHome.vue"),
      meta: {}
    },
    {
      path: "distributor-share-type",
      name: "Distributor Share Type",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorShareTypeComponents/distributorShareType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          37,
          1
        )
      }
    },
    {
      path: "add-distributor-share-type",
      name: "Add Distributor Share Type",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorShareTypeComponents/addDistributorShareType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          37,
          2
        )
      }
    },
    {
      path: "edit-distributor-share-type",
      name: "Edit Distributor Share Type",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorShareTypeComponents/editDistributorShareType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          37,
          2
        )
      }
    },
    {
      path: "view-distributor-share-type",
      name: "View Distributor Share Type",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorShareTypeComponents/viewDistributorShareType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          37,
          1
        )
      }
    },
    {
      path: "distributor-deduction",
      name: "Distributor Deduction",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorDeduction/distributorDeduction"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          38,
          1
        )
      }
    },
    {
      path: "add-distributor-deduction",
      name: "Add Distributor Deduction",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorDeduction/addDistributorDeduction"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          38,
          2
        )
      }
    },
    {
      path: "edit-distributor-deduction",
      name: "Edit Distributor Deduction",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorDeduction/editDistributorDeduction"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          38,
          2
        )
      }
    },
    {
      path: "view-distributor-deduction",
      name: "View Distributor Deduction",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorDeduction/viewDistributorDeduction"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          38,
          1
        )
      }
    },
    {
      path: "distributor-contract",
      name: "Distributor Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorContractComponents/distributorContract"
        ),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "Distributor",
            "RoleDistributor"
          ],
          false,
          "",
          145,
          1
        )
      }
    },
    {
      path: "add-distributor-contract",
      name: "Add Distributor Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorContractComponents/addDistributorContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          145,
          2
        )
      }
    },
    {
      path: "edit-distributor-contract",
      name: "Edit Distributor Share Contract Type",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorContractComponents/editDistributorContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleDistributor"],
          false,
          "",
          145,
          2
        )
      }
    },
    {
      path: "view-distributor-contract",
      name: "View Distributor Share Contract Type",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorContractComponents/viewDistributorContract"
        ),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "Distributor",
            "RoleDistributor"
          ],
          false,
          "",
          145,
          1
        )
      }
    },
    // DISTRIBUTORS
    {
      path: "distributors",
      name: "Distributors",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorsComponents/distributors"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          40,
          1
        )
      }
    },

    {
      path: "add-distributor",
      name: "Add Distributor",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorsComponents/addDistributor"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          40,
          2
        )
      }
    },
    {
      path: "edit-distributor",
      name: "Edit Distributor",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorsComponents/editDistributor"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          40,
          2
        )
      }
    },
    {
      path: "view-distributor",
      name: "View Distributor",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/DistributorsComponents/viewDistributor"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          40,
          1
        )
      }
    },
    {
      path: "contract",
      name: "Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/ContractComponents/contract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          39,
          1
        )
      }
    },
    {
      path: "add-contract",
      name: "Add Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/ContractComponents/addContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          39,
          2
        )
      }
    },
    {
      path: "view-contract",
      name: "View Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/ContractComponents/viewContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          39,
          1
        )
      }
    },
    {
      path: "edit-contract",
      name: "Edit Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/ContractComponents/editContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          39,
          2
        )
      }
    },
    //weekwise
    {
      path: "weekwise-contract",
      name: "Weekwise Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/WeekWiseContractComponents/weekwiseContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          146,
          1
        )
      }
    },
    {
      path: "add-weekwise-contract",
      name: "Add Weekwise Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/WeekWiseContractComponents/addWeekwiseContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          146,
          2
        )
      }
    },
    {
      path: "view-weekwise-contract",
      name: "View Weekwise Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/WeekWiseContractComponents/viewWeekwiseContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          146,
          1
        )
      }
    },
    {
      path: "edit-weekwise-contract",
      name: "Edit Weekwise Contract",
      component: () =>
        import(
          "@/components/Pages/DistributorContainer/WeekWiseContractComponents/editWeekwiseContract"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          146,
          2
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/distributorRoutes.js